import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SectionBlock from '../../SectionBlock';
import sortByOrder from '../../utils/sortByOrder';
import { titlesMap } from './utils';
import { fetchListingSupervision } from '@/store/slices/components/listingRegistration/service';
import { isControlListingEnabled } from '@/components/Properties/ListingRegistration/utils/listingSupervisionUtils';
import {
  DEVELOPMENTS_PENDING_REVIEW,
  PROPERTIES_PENDING_REVIEW,
} from '../../constants';

const TAB_ID = 'todo';
const UNASSIGNED_INQUIRIES = 'UnassignedInquiries';

function isPendingReviewCard(cardId) {
  return (
    cardId === PROPERTIES_PENDING_REVIEW ||
    cardId === DEVELOPMENTS_PENDING_REVIEW
  );
}

export default function PendingContent() {
  const dispatch = useDispatch();
  const tab = useSelector(
    (state) => state.DashboardSlice.edition.tabs?.[TAB_ID]
  );
  const { allPermissions } = useSelector(
    (state) => state.AuthSlice.permissions
  );
  const listingSupervision = useSelector(
    (state) => state.ListingRegistrationSlice.listingSupervision
  );

  const canSeeUnassigned = allPermissions.includes('can_manage_web_contacts');
  const isCompanyAdmin = allPermissions.includes('is_company_admin');
  const hasControlListing = isControlListingEnabled(listingSupervision);
  const isPortfolioManager = listingSupervision?.is_portfolio_manager === true;
  const canSeePendingReview =
    hasControlListing && (isCompanyAdmin || isPortfolioManager);

  useEffect(() => {
    dispatch(fetchListingSupervision());
  }, [dispatch]);

  const sections = (tab?.sections ?? [])
    .slice()
    .sort(sortByOrder)
    .map((section) => {
      const cards = (section.cards ?? [])
        .filter((card) => card.id !== UNASSIGNED_INQUIRIES || canSeeUnassigned)
        .filter((card) => !isPendingReviewCard(card.id) || canSeePendingReview)
        .slice()
        .sort(sortByOrder);

      return {
        ...section,
        cards,
        title: titlesMap[section.id],
        type: 'card',
      };
    });

  return sections.map((section) => (
    <SectionBlock
      key={section.id}
      tabId={TAB_ID}
      sectionId={section.id}
      cards={section.cards}
      order={section.order}
      visible={section.visible}
      title={section.title}
    />
  ));
}
